import { Duration as DurationLuxon } from 'luxon';
import { type } from '@mews-framework/utils';

interface Duration {
    value: string;
}

function Duration(luxonDuration: DurationLuxon): Duration {
    return type.create(Duration, {
        value: luxonDuration.toISO(),
    });
}

export default Duration;
